const style:any = () => ({
	container:{width:"100%", marginTop:45 },
});


export default style;